import { initialState } from '../EventsInitialState';

const reset = (state, payload) => {
  return initialState;
};

export { reset };
